/**
 * This is a helper function that takes a string and
 * returns the same, with first letter of every word in
 * the string as a capital letter.
 * @param str
 * @returns {string}
 * Example: "this is an example." -> "This Is An Example."
 */
export function toUpperCaseSentence(str) {
    if (Array.isArray(str)) {
        str = str[0]
    }
    return str
        .toLowerCase()
        .split(' ')
        .map(function(word) {
            return word[0].toUpperCase() + word.substr(1);
        })
        .join(' ');
}
